import {useParams} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useCodeRepositories} from '../hooks/useCodeRepositories.ts';
import {CodeRepository} from '../types';
import {FlexiCancelButton} from "@flexinet/ui-components";
import {useNavigate} from "react-router-dom";
import {AnalyzeRepositoryButton} from '../buttons/AnalyzeRepositoryButton';


export const DetailPage = () => {

    const {name: repositoryName} = useParams();
    const navigate = useNavigate();

    if (typeof repositoryName === 'undefined') {
        throw new Error('repositoryName is required parameter');
    }

    const {items, loading} = useCodeRepositories();

    const record = items.find((item: CodeRepository) => item.name === repositoryName);

    if (loading) {
        return <PlatformLoader message='Loading code repository...Please wait'/>;
    }

    if (!record) {
        return <PlatformLoader message='Code repository not found'/>;
    }

    const tools = [
        <AnalyzeRepositoryButton key={'analyze'} repositoryName={record.name}/>,
        <FlexiCancelButton key={'close'} onClick={() => navigate('/code-repositories')}/>
    ];

    return (
        <FormPageLayout
            title={record.name}
            pageNavigation={<EditPageNavigation component={record}/>}
            tools={tools}
        >
            <Grid>
                <Grid.Col span={{
                    base: 12,
                    lg: 6
                }}>
                    <Profile record={record}/>
                </Grid.Col>
            </Grid>
        </FormPageLayout>
    );
};
